// extracted by mini-css-extract-plugin
export var numpadContainer = "_s5-1";
export var phoneButton = "_s5-0";